export const HEADER_WEB_APP_VERSION = 'web-app-version';
export const HEADER_SESSION_EXPIRATION_DATE = 'session-expiration-date';
